(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5355],{

/***/ 86373:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/freelance-talent",
      function () {
        return __webpack_require__(94067);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 94067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ freelance_talent; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../ui-library/dist/index.js + 203 modules
var dist = __webpack_require__(78197);
// EXTERNAL MODULE: ./components/layout/Page.tsx + 19 modules
var Page = __webpack_require__(24882);
// EXTERNAL MODULE: ./components/shared/HeadMetadata.tsx
var HeadMetadata = __webpack_require__(73412);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(54933);
// EXTERNAL MODULE: ./components/layout/Page.styled.tsx
var Page_styled = __webpack_require__(29242);
// EXTERNAL MODULE: ./components/shared/HtmlTrans.tsx
var HtmlTrans = __webpack_require__(97210);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
// EXTERNAL MODULE: ./components/shared/FlexibleWrapper/FlexibleWrapper.tsx
var FlexibleWrapper = __webpack_require__(28902);
;// CONCATENATED MODULE: ./features/freelance-talent/hero/Hero.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: var(--surface-auxiliary-3-level-02-background, #d3d9f3);\n  color: #092c61;\n\n  padding: 4rem 0 5rem 0;\n  font-size: ",
        ";\n  min-height: 600px;\n  overflow: hidden;\n\n  .titles {\n    flex-direction: column-reverse;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto 1rem;\n  padding: 3rem 4rem 3rem 3rem;\n\n  @media (max-width: ",
        ") {\n    padding-bottom: clamp(4rem, 5vw, 6rem);\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  min-height: 500px;\n  max-width: 100%;\n  margin: 2rem auto 0;\n\n  color: var(--content-on-auxiliary-3-text, #0a053a);\n  text-align: center;\n  justify-content: center;\n\n  & > *:first-child {\n    order: 1;\n  }\n  & > *:nth-child(2) {\n    order: 0;\n  }\n\n  p {\n    margin: 0;\n  }\n\n  h1 {\n    font-size: clamp(",
        ", 2vw, ",
        ");\n    font-weight: 800;\n    text-wrap: balance;\n    margin: 0 0 1.5rem 0;\n  }\n\n  img {\n    display: block;\n    margin: 0 auto;\n    max-width: 100%;\n    height: auto;\n  }\n\n  br {\n    display: none;\n  }\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    align-items: center;\n    gap: var(--gap-components-gutter, 32px);\n    max-width: 100%;\n    margin: 0;\n\n    & > * {\n      flex: 1;\n      min-width: 0;\n    }\n    & > *:first-child {\n      order: 0;\n    }\n    & > *:nth-child(2) {\n      order: 1;\n    }\n\n    br {\n      display: block;\n    }\n  }\n\n  @media (min-width: ",
        ") {\n    text-align: left;\n\n    h1 {\n      font-size: clamp(",
        ", 3vw, ",
        ");\n      margin-top: 3rem;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & > span:last-child > span {\n    white-space: normal;\n    font-size: clamp(",
        ", 1.2vw, ",
        ");\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: left;\n  & > span:last-child > span {\n    white-space: normal;\n    font-size: clamp(",
        ", 1.2vw, ",
        ");\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2a0f81cf-0"
})(_templateObject(), (0,theme/* fontSize */.JB)("lg"));
var OuterWrapper = (0,styled_components_browser_esm/* default */.ZP)(FlexibleWrapper/* default */.Z).attrs({
    imagePath: "/images/common/irregular-box-4.svg",
    backgroundColor: "var(--surface-auxiliary-3-level-02-background, #B0B7E7)"
}).withConfig({
    componentId: "sc-2a0f81cf-1"
})(_templateObject1(), (0,theme/* screen */.sp)("md2"));
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2a0f81cf-2"
})(_templateObject2(), (0,theme/* fontSize */.JB)("xl2"), (0,theme/* fontSize */.JB)("xl3"), (0,theme/* screen */.sp)("md2"), (0,theme/* screen */.sp)("xl"), (0,theme/* fontSize */.JB)("xl3"), (0,theme/* fontSize */.JB)("xl5"));
var CTAs = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2a0f81cf-3"
})(_templateObject3(), (0,theme/* screen */.sp)("xl"));
var StyledButtonLink = (0,styled_components_browser_esm/* default */.ZP)(dist/* ButtonLink */.ZP).withConfig({
    componentId: "sc-2a0f81cf-4"
})(_templateObject4(), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontSize */.JB)("sm"));
var TemporalDisabledButton = (0,styled_components_browser_esm/* default */.ZP)(dist/* Button */.zx).withConfig({
    componentId: "sc-2a0f81cf-5"
})(_templateObject5(), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontSize */.JB)("sm"));
var HeroStyles = {
    Root: Root,
    OuterWrapper: OuterWrapper,
    Content: Content,
    CTAs: CTAs,
    StyledButtonLink: StyledButtonLink,
    TemporalDisabledButton: TemporalDisabledButton
};

// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
;// CONCATENATED MODULE: ./features/freelance-talent/hero/Hero.tsx










var Hero = function() {
    var t = (0,useI18n/* useI18n */.Q)("freelance-talent").t;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroStyles.Root, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Page_styled/* PageContentContainer */.R, {
            containerSize: "xlMax",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroStyles.OuterWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroStyles.Content, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* StackItem */.vO, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (0,paths/* getPublicPath */.A)("/images/freelance-talent/hero-image.png"),
                                alt: "Freelance talent hero image"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* StackItem */.vO, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                                direction: "column",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* StackItem */.vO, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Header */.h4, {
                                                editorial: true,
                                                as: "h1",
                                                size: "5xl",
                                                children: t("freelance-talent.hero.title")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                                ns: "freelance-talent",
                                                i18nKey: "freelance-talent.hero.subtitle"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroStyles.CTAs, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroStyles.StyledButtonLink, {
                                            href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.blog */.uu.blog, locale)).concat(locale === "en" ? "/guide-for-freelance-newbies-in-tech" : "/guia-para-freelance-novatos-en-tech-manfred"),
                                            schema: "brand1",
                                            variant: "ghost",
                                            label: t("freelance-talent.hero.cta2"),
                                            startIcon: pro_solid_svg_icons/* faDownload */.q7m
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./features/freelance-talent/FreelanceTalentPage.tsx

function FreelanceTalentPage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      #freshworks-container iframe {\n        bottom: 90px !important;\n      }\n    "
    ]);
    FreelanceTalentPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var Features = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6890).then(__webpack_require__.bind(__webpack_require__, 16890));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16890)
            ];
        }
    },
    ssr: false
});
var FreelanceTalentPage = function(param) {
    var bannerText = param.bannerText;
    var t = (0,useI18n/* useI18n */.Q)("freelance-talent").t;
    var PageGlobalStyles = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(FreelanceTalentPage_templateObject());
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageGlobalStyles, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMetadata/* default */.Z, {
                title: t("freelance-talent.page_title"),
                desc: t("freelance-talent.page_description"),
                url: app_urls/* APP_URLS.freelanceTalent */.uu.freelanceTalent,
                imgUrl: "".concat((0,paths/* getPublicPath */.A)("/images/cards/card_freelance_talent.png")),
                indexable: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.ZP, {
                hasScrollTop: true,
                pageVariant: "midnight_light",
                bannerText: bannerText,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                    direction: "column",
                    gap: "5xl",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Features, {})
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/freelance-talent.tsx

var __N_SSG = true;
/* harmony default export */ var freelance_talent = (FreelanceTalentPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7482,625,4882,7104,9774,2888,179], function() { return __webpack_exec__(86373); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);